/* eslint-disable max-len */
export default {
    video: {
        copy: 'Kopiuj',
        copied: 'Skopiowano',
        video_id: '4gzisBJRwkk',
        subject: 'Lemlock Video'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/pl/modals.js